export const BoardName = {
  KANBAN: "Kanban",
  SPRINT: "Sprint",
  STRATEGY: "Strategy",
  TODO: "Todo",
  REQUESTER: "Requester",
  RISK_MITIGATION: "Risk Mitigation",
};
